import { render, staticRenderFns } from "./select-queue-type.vue?vue&type=template&id=0bc57ea5&"
import script from "./select-queue-type.vue?vue&type=script&lang=js&"
export * from "./select-queue-type.vue?vue&type=script&lang=js&"
import style0 from "./select-queue-type.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports